/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" _fill="#fff" d="M.622 1.84l.892-.892 8.028 8.027-.892.892z"/><path pid="1" _fill="#fff" d="M8.651.947l.892.892-8.028 8.028-.892-.892z"/>'
  }
})
